import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { GenerateFormType } from './generate-form-type.enum';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { GenerateForm } from './generate-form';

@Component({
  selector: 'app-generate-form',
  templateUrl: './generate-form.component.html',
  styleUrls: ['./generate-form.component.scss']
})
export class GenerateFormComponent implements OnInit {

  @Input('settings')
  get settings(): GenerateForm[] {
    return this.SETTINGS;
  }
  set settings(value: GenerateForm[]) {
    this.SETTINGS = value;
  }
  private SETTINGS: GenerateForm[];

  @Input() col: string;
  @Input() showSubmitButton = true;
  @Input() showCancelButton: boolean;
  @Input() buttonSubmitText = 'Salvar';
  @Input() buttonCancelText = 'Cancelar';
  @Input() showLoading: boolean;

  @Output() formData: EventEmitter<any> = new EventEmitter();

  type = GenerateFormType;
  submit: boolean;
  generateFormGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder
  ) { }

  ngOnInit() {
    this.initilizeComponent();
    this.submit = false;
  }

  initilizeComponent() {
    this.generateFormGroup = this.formBuilder.group({});

    this.settings.forEach(e => {
      this.generateFormGroup.addControl(
        e.id, new FormControl({
          value: e.value ? e.value : null, disabled: e.disabled ? e.disabled : null
        }, e.validator ? e.validator : null
        ));
    });
  }

  submitButton() {
    this.generateFormGroup.markAllAsTouched();
    if (this.validSubmit()) {
      this.formData.emit({ data: this.generateFormGroup.value, isCancel: false });
    }
  }

  cancelButton() {
    this.formData.emit({ isCancel: true });
  }

  validSubmit(): boolean {
    this.submit = true;

    if (this.generateFormGroup.valid) {
      return true;
    } else {
      return false;
    }
  }
}
